import { Button } from '@mui/material';
import React, { useState } from 'react';
import StepperStore from '../../../../LocalForage/StepperStore';
import AiciSetupInterface from '../../../../Objects/interfaces/AiciSetup';
import Layout from './Layout';
import { ENV_TEACHR, ENV_VERIFIED_TRAINER, isBrandActive } from '../../../../config/environment.config';

const Intro = (props: any) => {
    const handleClick = () => {
        let screenState:AiciSetupInterface = {
            currentStep: 1,
            key: '',
            paiment: {
                bic: null,
                iban: null
            },
            Parent: {
                first: {
                    firstName: null,
                    name: null,
                    mail: '',
                    telephone: null,
                },
                second: {
                    address: null,
                    birthDay: null,
                    country: null,
                    gender: null,
                    isBornFrance: null,
                    zipCode: null,
                    city: null,
                    birthName: null
                }
            },
            student: {
                firstName: null,
                level: null
            },
        }
        StepperStore.setItem('dashboard_setup',screenState)
        props.nextStep(1)
    }
    return (
        <div>
            <Layout next={<Button onClick={() => handleClick()} className='w-full py-2 font-extrabold text-white uppercase rounded-full md:text-base px-14 bg-first md:w-max'>C’EST PARTI !</Button>}>
                <h2 className='text-lg font-bold underline md:text-xl text-first underline-offset-8'> {isBrandActive(ENV_TEACHR) ? "Ajout d’un élève ✏️" : "Ajout d’un client ✏️"} </h2>
                <p className='text-base font-bold leading-2 text-normal py-4'>Pour ajouter un {isBrandActive(ENV_TEACHR) ? "élève": "client"} vous aurez besoin des informations ci-dessous. <br />
                Si vous ne pouvez pas toutes les compléter, votre élève ou son parent recevra à son tour ce formulaire et pourra finaliser son inscription. <br />
                Votre élève paie lui-même ses cours particuliers ? Dans ce cas, Veuillez remplir les mêmes informations dans les champs "Parent" et "Élève".</p>
                <div className="flex flex-col gap-8 pt-2 md:flex-row">
                    <ul className='list-disc list-inside'>
                        <h3 className='mb-2 text-base font-bold text-first'>Parent :</h3>
                        <li className='font-medium text-normal text-sm'>Prénom & Nom de famille</li>
                        <li className='font-medium text-normal text-sm'>E-mail</li>
                        <li className='font-medium text-normal text-sm'>Téléphone </li>
                        <li className='font-medium text-normal text-sm'>Civilité </li>
                        <li className='font-medium text-normal text-sm'>Date de naissance & Commune de naissance & Pays de naissance</li>
                        <li className='font-medium text-normal text-sm'>Adresse postale  </li>
                        <li className='font-medium text-normal text-sm'>IBAN</li>
                        <li className='font-medium text-normal text-sm'>BIC</li>
                    </ul>
                    <ul className='list-disc list-inside'>
                        <h3 className='mb-2 text-base font-bold text-first'>Élève :</h3>
                        <li className='font-medium text-normal text-sm'>Prénom</li>
                        {/* <li className='font-medium text-normal text-sm'>Niveau scolaire</li> */}
                    </ul>
                </div>
            </Layout>
        </div>
    );
};

export default Intro;